import React, {useEffect, useState} from 'react'
import axios from 'axios'

import {Modal} from 'react-bootstrap'
import {Modal as ModalVanilla} from 'bootstrap'

import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import DatePicker from 'react-datepicker'

import '../../../../node_modules/react-big-calendar-scheduler/lib/css/react-big-calendar.css'
import '../../../../node_modules/react-datepicker/dist/react-datepicker.css'
import {EventosBanner} from '../../components/Eventos/EventosBanner'
import {EventosCarrusel} from '../../components/Eventos/EventosCarrusel'

import './Eventos.css'

function Eventos() {
  const url = 'https://puntosurgdl.com/backend/'

  const [eventosCarrusel, setEventosCarrusel] = useState('')

  const [showNewEventoCarrusel, setShowNewEventoCarrusel] = useState(false)

  const handleCloseNewEventoCarrusel = () => setShowNewEventoCarrusel(false)
  const handleShowNewEventoCarrusel = () => setShowNewEventoCarrusel(true)

  const [showDeleteEventoCarrusel, setShowDeleteEventoCarrusel] = useState(false)
  const [deleteEventoCarruselId, setDeleteEventoCarruselId] = useState('')

  const [deleteEventId, setDeleteEventId] = useState('')

  const [myModalElement, setMyModalElement] = useState('')

  const handleCloseDeleteEventoCarrusel = () => setShowDeleteEventoCarrusel(false)
  const handleShowDeleteEventoCarrusel = (idElement) => {
    console.log(idElement)
    setShowDeleteEventoCarrusel(true)
    setDeleteEventoCarruselId(idElement)
  }

  const [showDeleteEvent, setShowDeleteEvent] = useState(false)
  const handleCloseDeleteEvent = () => setShowDeleteEvent(false)
  const handleShowDeleteEvent = () => setShowDeleteEvent(true)

  const weekday = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
  const month = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ]

  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState('')

  const [showNewEvent, setShowNewEvent] = useState(false)

  const handleCloseNewEvent = () => setShowNewEvent(false)
  const handleShowNewEvent = () => setShowNewEvent(true)

  function formatAMPM(date) {
    var hours = date.getHours()
    var minutes = date.getMinutes()
    var ampm = hours >= 12 ? 'pm' : 'am'
    hours = hours % 12
    hours = hours ? hours : 12 // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes
    var strTime = hours + ':' + minutes + ' ' + ampm
    return strTime
  }

  function toIsoString(date) {
    var tzo = -date.getTimezoneOffset(),
      dif = tzo >= 0 ? '+' : '-',
      pad = function (num) {
        return (num < 10 ? '0' : '') + num
      }

    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':' +
      pad(date.getSeconds()) +
      dif +
      pad(Math.floor(Math.abs(tzo) / 60)) +
      ':' +
      pad(Math.abs(tzo) % 60)
    )
  }

  useEffect(() => {
    getEvents()
    getEventosCarrusel()
  }, [])

  const [events, setEvents] = useState('')

  const getEvents = () => {
    axios
      .get(url + 'getEvents.php')
      .then((response) => {
        let events = response.data

        console.log('EVENTOS')
        console.log(response.data)
        setEvents(events)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const getEventosCarrusel = () => {
    axios
      .get(url + 'getEventosCarrusel.php')
      .then((response) => {
        console.log(response.data.data)
        setEventosCarrusel(response.data.data)
        // setEventosCarrusel(promos)
      })
      .catch((error) => console.error('Error: ' + error))
  }

  const handleEventClick = ({event, el}) => {
    //myModal.toggle()
    // var myModal = new ModalVanilla(document.getElementById('modalEvents'), {})
    let myModal = new ModalVanilla(document.getElementById('modalEvents'), {})

    myModal.toggle()

    console.log(event.id)
    setDeleteEventId(event.id)

    let eventStartDate = new Date(event.start)

    let modalEvent = document.getElementById('modalEvents')
    modalEvent.getElementsByClassName(
      'modal-background'
    )[0].style.backgroundImage = `url(${event.extendedProps.imgUrl})`
    modalEvent.getElementsByClassName('modal-title')[0].innerHTML = event.title
    modalEvent.getElementsByClassName('fecha-evento')[0].innerHTML =
      weekday[eventStartDate.getDay()] +
      ' ' +
      eventStartDate.getDate() +
      ' de ' +
      month[eventStartDate.getMonth()]
    modalEvent.getElementsByClassName('hora-evento')[0].innerHTML = formatAMPM(eventStartDate)
    modalEvent.getElementsByClassName('ubicacion-evento')[0].innerHTML =
      event.extendedProps.location
    modalEvent.getElementsByClassName('tipo-evento')[0].innerHTML = event.extendedProps.category
    console.log(event.extendedProps.category)
  }

  const uploadNewEvent = () => {
    const data = new FormData()

    data.append('title', document.getElementById('new-event-title').value)
    data.append('start', toIsoString(startDate))
    if (endDate) {
      data.append('end', toIsoString(endDate))
    } else {
      data.append('end', '')
    }
    data.append('location', document.getElementById('new-event-location').value)
    data.append('category', document.getElementById('new-event-category').value)
    data.append('type', document.getElementById('new-event-type').value)
    if (document.getElementById('new-event-img').files.length !== 0) {
      for (let i = 0; i < document.getElementById('new-event-img').files.length; i++) {
        data.append('file[]', document.getElementById('new-event-img').files[i])
      }
    }

    axios
      .post(url + 'uploadNewEvent.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setEvents(res.data)
          handleCloseNewEvent()
          // setPromos(res.data.data)
          // handleCloseNewPromo()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const deleteEvent = () => {
    console.log(deleteEventId)
    const data = {
      id: deleteEventId,
    }

    axios
      .post(url + 'deleteEvent.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res)
          // console.log(res.data)
          setEvents(res.data)
          // handleCloseDeleteEvent()
        },
        (error) => {
          alert(error)
        }
      )
  }

  const uploadNewEventoCarrusel = () => {
    const data = new FormData()

    if (document.getElementById('file-eventos-carrusel-new').files.length !== 0) {
      for (let i = 0; i < document.getElementById('file-eventos-carrusel-new').files.length; i++) {
        data.append('file[]', document.getElementById('file-eventos-carrusel-new').files[i])
      }

      data.append('name', '')

      axios
        .post(url + 'uploadNewEvento.php', data, {
          // receive two parameter endpoint url ,form data
        })
        .then(
          (res) => {
            // then print response status
            console.log(res.data)
            setEventosCarrusel(res.data.data)
            handleCloseNewEventoCarrusel()
          },
          (error) => {
            alert(error)
          }
        )
    } else {
      console.log('vacío')
    }
  }

  const deleteEventoCarrusel = (idElement) => {
    console.log('delete promo')
    console.log(idElement)

    const data = {
      name: idElement,
    }

    axios
      .post(url + 'deleteEventoCarrusel.php', data, {
        // receive two parameter endpoint url ,form data
      })
      .then(
        (res) => {
          // then print response status
          console.log(res.data)
          setEventosCarrusel(res.data.data)
          handleCloseDeleteEventoCarrusel()
        },
        (error) => {
          alert(error)
        }
      )
  }

  return (
    <div className='row g-5'>
      <EventosBanner />

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Eventos, Talleres y Happenings</h3>
            <div className='mt-10 mb-10 float-end'>
              <button type='button' className='btn btn-primary' onClick={handleShowNewEvent}>
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <FullCalendar
              plugins={[dayGridPlugin]}
              initialView='dayGridMonth'
              events={events}
              eventClick={handleEventClick}
            />
          </div>
        </div>
      </div>

      <div className='modal fade modal-events' tabIndex={-1} id='modalEvents'>
        <div className='modal-dialog'>
          <div className='modal-background'>
            <div className='modal-content item'>
              <div
                className='btn btn-icon btn-sm btn-active-light-primary ms-auto float-end btn-close-modal-events'
                data-bs-dismiss='modal'
                aria-label='Close'
              >
                <img src='/admin/media/icons/duotune/arrows/arr061.svg' />
              </div>
              <div>
                <div>
                  <h2 class='modal-title'>ENCUENTRO INTERNACIONAL DEL MARIACHI Y LA CHARRERIA</h2>
                  <p class='fecha-evento'>Jueves 1 de Octubre</p>
                  <p class='hora-evento'>5:30 pm</p>
                  <p class='ubicacion-evento'>Salón Balcony</p>
                  <p class='tipo-evento'>Música regional</p>
                </div>
              </div>
              <div className='row'>
                <button
                  type='button'
                  className='btn btn-danger col-md-3 ms-auto'
                  data-bs-dismiss='modal'
                  aria-label='Close'
                  onClick={() => deleteEvent()}
                >
                  Eliminar
                </button>
              </div>

              {/* <div className='modal-footer'>
              <button type='button' className='btn btn-light' data-bs-dismiss='modal'>
                Close
              </button>
              <button type='button' className='btn btn-primary'>
                Save changes
              </button>
            </div> */}
            </div>
          </div>
        </div>
      </div>

      <Modal show={showDeleteEvent} onHide={handleCloseDeleteEvent}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar el evento?</p>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseDeleteEvent}>
            Cerrar
          </button>
          <button type='button' className='btn btn-danger' onClick={() => deleteEvent()}>
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showNewEvent} onHide={handleCloseNewEvent} className='modal-new-event'>
        <Modal.Header closeButton>
          <Modal.Title>Agregar evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Titulo:</label>
              <input type='text' className='form-control' id='new-event-title' />
            </div>
            <div className='form-group col-md-10'>
              <label>Fecha inicio:</label>
              <DatePicker
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                timeInputLabel='Hora:'
                dateFormat='MM/dd/yyyy h:mm aa'
                showTimeInput
              />
            </div>
            <div className='form-group col-md-10'>
              <label>Fecha fin:</label>
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                timeInputLabel='Hora:'
                dateFormat='MM/dd/yyyy h:mm aa'
                showTimeInput
              />
            </div>
            <div className='form-group col-md-10'>
              <label>Ubicación:</label>
              <input type='text' className='form-control' id='new-event-location' />
            </div>
            <div className='form-group col-md-10'>
              <label>Categoría:</label>
              <input id='new-event-category' type='text' className='form-control' />
            </div>
            <div className='form-group col-md-10'>
              <label>Tipo:</label>
              <select id='new-event-type' className='form-select'>
                <option value={`happenings`}>Happenings</option>
                <option value={`talleres`}>Talleres</option>
                <option value={`eventos`}>Eventos</option>
              </select>
            </div>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input id='new-event-img' type='file' className='form-control' />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button type='button' className='btn btn-secondary' onClick={handleCloseNewEvent}>
            Cerrar
          </button>
          <button type='button' className='btn btn-primary' onClick={uploadNewEvent}>
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <div className='col-lg-12'>
        <div className='card card-custom card-stretch shadow mb-5'>
          <div className='card-header'>
            <h3 className='card-title'>Carrusel de eventos</h3>
            <h5 className='card-subtitle'>
              Las imágenes deben tener una medida de 1920px por 800px y no pesar más de 1MB
            </h5>
            <div className='mt-n16 mb-10 float-end'>
              <button
                type='button'
                className='btn btn-primary'
                onClick={handleShowNewEventoCarrusel}
              >
                Agregar
              </button>
            </div>
          </div>
          <div className='card-body'>
            <div className='row'>
              <EventosCarrusel
                eventos={eventosCarrusel}
                deleteEvento={handleShowDeleteEventoCarrusel}
                setEventosCarrusel={setEventosCarrusel}
              />
            </div>
          </div>
          <div className='card-footer d-none'>
            <p className='ms-auto float-end'>
              Las imágenes deben tener una medida de 1920px por 800px y no pesar más de 1MB
            </p>
          </div>
        </div>
      </div>

      <Modal show={showNewEventoCarrusel} onHide={handleCloseNewEventoCarrusel}>
        <Modal.Header closeButton>
          <Modal.Title>Agregar imagen evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className='row'>
            <div className='form-group col-md-10'>
              <label>Seleccione imagen:</label>
              <input
                id='file-eventos-carrusel-new'
                type='file'
                className='form-control'
                accept='image/*'
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={handleCloseNewEventoCarrusel}
          >
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-primary'
            onClick={() => uploadNewEventoCarrusel()}
          >
            Guardar
          </button>
        </Modal.Footer>
      </Modal>

      <Modal show={showDeleteEventoCarrusel} onHide={handleCloseDeleteEventoCarrusel}>
        <Modal.Header closeButton>
          <Modal.Title>Eliminar imagen promoción</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Está seguro que desea eliminar la imagen de promoción?</p>
        </Modal.Body>
        <Modal.Footer>
          <button
            type='button'
            className='btn btn-secondary'
            onClick={handleCloseDeleteEventoCarrusel}
          >
            Cerrar
          </button>
          <button
            type='button'
            className='btn btn-danger'
            onClick={() => deleteEventoCarrusel(deleteEventoCarruselId)}
          >
            Eliminar
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export {Eventos}
